module.exports = __webpack_public_path__ + "media/application/images/section_images/news-3e7cbafb0a56c846942efd003849af09.jpg";